import { render, staticRenderFns } from "./TitleExpenseModal.vue?vue&type=template&id=5a2dc43e&"
import script from "./TitleExpenseModal.vue?vue&type=script&lang=js&"
export * from "./TitleExpenseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports